import React from 'react'
import Icon from 'react-icon-base'

const StarEmpty = props => {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <title>{props.title || 'Star-Empty'}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g stroke="#F9BF00">
          <path d="M14.4149055,6.50778699 L9.96650226,5.82963728 L9.85289956,5.58877268 L7.99978321,1.65939651 L6.0335367,5.82963134 L5.77022882,5.86977207 L1.5776195,6.50886977 L4.8072668,9.80248587 L4.76622274,10.0525759 L4.04940067,14.4189972 L7.99965123,12.2413268 L8.24102803,12.3743694 L11.949704,14.4188336 L11.1928076,9.80288899 L11.3696559,9.62203171 L14.4149055,6.50778699 Z M4.03255885,14.588468 C4.03252835,14.5884236 4.03249783,14.5883793 4.03246729,14.5883351 Z M3.88714866,14.5000131 C3.88667315,14.5000044 3.88620118,14.5 3.88573284,14.5 C3.88671005,14.5 3.88860849,14.4996521 3.89145519,14.4988551 Z" />
        </g>
      </g>
    </Icon>
  )
}

export default StarEmpty
